'use client';

import React from 'react';

import Link from 'next/link';

import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';
import SinglePointMap from '@/components/layout/LocationSection/SinglePointMap';

import type { GettingHereLocationSectionData } from './types';

interface Props {
  data: GettingHereLocationSectionData;
}

const GettingHereLocationSection: React.FC<Props> = ({ data }) => {
  const { clinicName, address, coordinates, googleMapsLink, callSection } =
    data;

  const mapMarkers = coordinates
    ? [
        {
          text: `${coordinates.lat},${coordinates.lng}`,
          title: clinicName.content,
          heading: { content: clinicName.content, styles: {} },
        },
      ]
    : [];

  return (
    <section
      id="location-map"
      className="content-wrapper pt-8 pb-4 lg:pt-10 lg:pb-8"
    >
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.25fr_1fr] lg:gap-16">
        {coordinates && (
          <div className="min-h-90 md:min-h-120">
            <div className="h-90 w-full overflow-hidden rounded-[28px] md:h-120">
              <SinglePointMap markers={mapMarkers} zoomLevel={15} />
            </div>
          </div>
        )}

        <div className="max-w-130">
          <RichText styles={clinicName.styles}>{clinicName.content}</RichText>
          <RichText styles={address.styles}>{address.content}</RichText>

          <div className="mb-8 flex items-center gap-3">
            <R2Image
              path="/images/gettingHere/map-logo.svg"
              alt="Google Maps"
              width={32}
              height={32}
            />
            <Link
              href={googleMapsLink.href}
              target="_blank"
              rel="noreferrer"
              className={googleMapsLink.className}
            >
              {googleMapsLink.text}
            </Link>
          </div>

          <RichText styles={callSection.heading.styles}>
            {callSection.heading.content}
          </RichText>

          <Link
            href={callSection.button.link}
            className={callSection.button.className}
          >
            {callSection.button.label}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GettingHereLocationSection;
